var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "white",
    fillOpacity: 0.06
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_307_7561)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.1696 11.296V20.704C6.1696 21.3088 6.4864 21.856 7.0144 22.1632L15.1648 26.8672C15.6832 27.1648 16.3264 27.1648 16.8448 26.8672L24.9952 22.1632C25.5136 21.8656 25.84 21.3088 25.84 20.704V11.296C25.84 10.6912 25.5232 10.144 24.9952 9.8368L16.8448 5.1328C16.3264 4.8352 15.6832 4.8352 15.1648 5.1328L7.0144 9.8368C6.496 10.1344 6.1792 10.6912 6.1792 11.296H6.1696Z",
    fill: "white",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.776 17.824L16.6144 21.0112C16.5856 21.0976 16.5856 21.1936 16.6144 21.2896L18.6112 26.7712L20.9248 25.4368L18.1504 17.824C18.0832 17.6512 17.8432 17.6512 17.776 17.824Z",
    fill: "white",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1088 12.4672C20.0416 12.2944 19.8016 12.2944 19.7344 12.4672L18.5728 15.6544C18.544 15.7408 18.544 15.8368 18.5728 15.9328L21.8464 24.9088L24.16 23.5744L20.1088 12.4768V12.4672Z",
    fill: "white",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 5.488C16.0576 5.488 16.1152 5.5072 16.1632 5.536L24.976 10.624C25.0816 10.6816 25.1392 10.7968 25.1392 10.912V21.088C25.1392 21.2032 25.072 21.3184 24.976 21.376L16.1632 26.464C16.1152 26.4928 16.0576 26.512 16 26.512C15.9424 26.512 15.8848 26.4928 15.8368 26.464L7.024 21.376C6.9184 21.3184 6.8608 21.2032 6.8608 21.088V10.9024C6.8608 10.7872 6.928 10.672 7.024 10.6144L15.8368 5.5264C15.8848 5.4976 15.9424 5.4784 16 5.4784V5.488ZM16 4C15.6832 4 15.376 4.0768 15.088 4.24L6.2752 9.328C5.7088 9.6544 5.3632 10.2496 5.3632 10.9024V21.0784C5.3632 21.7312 5.7088 22.3264 6.2752 22.6528L15.088 27.7408C15.3664 27.904 15.6832 27.9808 16 27.9808C16.3168 27.9808 16.624 27.904 16.912 27.7408L25.7248 22.6528C26.2912 22.3264 26.6368 21.7312 26.6368 21.0784V10.9024C26.6368 10.2496 26.2912 9.6544 25.7248 9.328L16.9024 4.24C16.624 4.0768 16.3072 4 15.9904 4H16Z",
    fill: "#D0D0D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1632 24.9184L10.9792 22.6912L12.6112 24.0448L11.0848 25.4464L10.1632 24.9184Z",
    fill: "#3C3C3C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2512 10.1824H13.0144C12.8512 10.1824 12.6976 10.288 12.64 10.4416L7.84961 23.5744L10.1632 24.9088L15.4432 10.4416C15.4912 10.3072 15.3952 10.1728 15.2608 10.1728L15.2512 10.1824Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.168 10.1824H16.9312C16.768 10.1824 16.6144 10.288 16.5568 10.4416L11.0848 25.4368L13.3984 26.7712L19.3504 10.4416C19.3984 10.3072 19.3024 10.1728 19.168 10.1728V10.1824Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_307_7561"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(4 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArb);
export default __webpack_public_path__ + "static/media/ARB.0f33feb22b8caf377f0ebfb3d99bcc55.svg";
export { ForwardRef as ReactComponent };